<template>
  <div class="container">
    <div class="package-banner-card border-0 card">
      <div class="card-body d-flex flex-column justify-content-between text-center p-3">
        <div>
          <div class="text-uppercase font-weight-bold text-white-50" style="font-size: 0.8em">
            {{ $t('pages.checkins_detail.package_banner_pretitle') }}
          </div>
          <div class="font-weight-bolder pt-1 h4">{{ $t('pages.checkins_detail.package_banner_title_all_photos') }}</div>
          <div class="text-white-50 pb-2"> {{ $t('pages.checkins_detail.package_banner_unit', {price: avgPrice}) }}</div>
        </div>
        <div class="pb-2 h4 font-weight-normal" v-if="data.price_original !== data.price">
          <del class="text-white-50"> {{ data.price_original|formatCurrency(currency) }}</del>
        </div>

        <div class="align-self-center w-100">
          <button-with-spinner
              class="btn btn-primary btn-xs-block btn-sm-block btn-md-block"
              :disabled="inCart" @click="emitClickEvent" :loading="loading">
            <template v-if="inCart">
              {{ $t('pages.checkins_detail.package_banner_btn_added') }}
            </template>
            <template v-else>
                        <span :class="{'d-lg-inline d-none': data.price}">{{
                            data.price ? $t('pages.checkins_detail.package_banner_btn_buy_now') : $t('pages.checkins_detail.package_banner_btn_add')
                          }}</span> {{ data.price|formatCurrency(currency) }}
            </template>

          </button-with-spinner>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ButtonWithSpinner from '@/components/ButtonWithSpinner'

export default {
  name: "PackageCustom",
  emits: ['activate-custom-package'],
  components: {ButtonWithSpinner},
  props: {
    data: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    inCart: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    avgPrice() {
      return this.$options.filters.formatCurrency(this.data.unit_price_avg, this.currency)
    }
  },
  methods: {
    async emitClickEvent() {
      this.loading = true
      this.$emit('activate-custom-package')
      await this.wait(1000)
      this.loading = false
    }
  }
}
</script>
